import { Tooltip, Badge, Text, useColorModeValue, useClipboard, keyframes, Box } from '@chakra-ui/react'
import toast from 'utils/toast'
import { useAuthentication } from 'contexts/Authentication/Provider'

type Params = {
  id?: string
}

function getShortId(id: string) {
  const split = id.split('')
  let shortVersion = ''
  if (split[0] == '1') {
    let idWithoutOne = id.substring(1, split.length)

    for (let i = split.length - 2; i >= 0; i--) {
      if (idWithoutOne.split('')[0] == '0') {
        idWithoutOne = idWithoutOne.substring(1, i + 1)
      } else {
        shortVersion = idWithoutOne
      }
    }

    if (id == '1000000000') {
      shortVersion = '0'
    }
  } else {
    shortVersion = id
  }

  return shortVersion
}

export default function Id({ id }: Params) {
  const { onCopy } = useClipboard(id || '')
  const shortId = getShortId(id?.toString() || '')
  const tooltipBg = useColorModeValue('gray.500', 'gray.300')
  const { user } = useAuthentication()

  const isFabio = user?.name == 'FABIO VITOR DE OLIVEIRA NORONHAAAA'

  function onClickForCopy(e: any) {
    onCopy()
    toast.success('Id copiado!')
    e.stopPropagation()
  }

  if (!id) {
    return <Text>-</Text>
  }

  if (isFabio) {
    const rainbow_animation = keyframes`
 0%,100% {
        background-position: 0 0;
    }

    50% {
        background-position: 100% 0;
    }
  `
    return (
      <Box>
        <Text
          as="h3"
          textAlign="center"
          textDecoration="underline"
          fontSize="32px"
          fontFamily="monospace"
          letterSpacing="5px"
          /* */
          background="linear-gradient(to right, #6666ff, #0099ff , #00ff00, #ff3399, #6666ff)"
          backgroundClip="text"
          color="transparent"
          animation={`${rainbow_animation} 6s ease-in-out infinite`}
          backgroundSize="400% 100%"
          sx={{
            '-webkit-background-clip': 'text',
          }}
        >
          {id}
        </Text>
      </Box>
    )
  }

  return (
    <Tooltip label={id} bg={tooltipBg}>
      <Badge width="max-content" variant="subtle" colorScheme="gray" onClick={onClickForCopy} cursor="copy">
        <Text as="span" fontSize="xs">
          #
        </Text>
        {shortId}
      </Badge>
    </Tooltip>
  )
}
